import { render, staticRenderFns } from "./ArchivoPdf.vue?vue&type=template&id=3055a7ee"
import script from "./ArchivoPdf.vue?vue&type=script&lang=js"
export * from "./ArchivoPdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports